import React, { Component } from "react";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
import MoreOptions from "./moreOptions";
// import ClaimOptions from "./claimsOptions";
// import Spinner from "react-bootstrap/Spinner";
import PatientRegistration from "./patientRegistration";
import UpdatePatient from "./updatePatient";
// import ClaimSubmission from "./claimSubmission";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import settings from "../helpers/Settings";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import IconButton from "@mui/material/IconButton";
// import MenuItem from '@mui/material/MenuItem';
// import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import UpdateClaim from "./updateClaim";
import * as moment from "moment";
// import Menu from "@mui/material/Menu";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Cookies from "js-cookie";
import Accordion from "react-bootstrap/Accordion";
// import Container from "react-bootstrap/Container";
// import CheckStatus from "./checkStatus";
// import CancelRequest from "./cancelRequest";
// import CommunicationRequest from "./communicationRequest";
// import Checkbox from "@mui/material/Checkbox";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import SearchIcon from "@mui/icons-material/Search";
// import { CSVLink } from "react-csv";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import CircularProgress from "@mui/material/CircularProgress";
let { KayanURL } = settings;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
class Patients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registerModuleScreen: false,
      patients: true,
      claimModal: false,
      patientInfoModalOpen: false,
      patientupdate: false,
      claimResponseFlage: false,
      authResponseFlage: false,
      searchInfo: {},
      viewPatientInfo: false,
      searchNotFound: false
    };
  }
  componentDidMount = async () => {
    this.getAllPatients();
  };
  handleSearchRequest = async () => {
    let { searchInfo } = this.state;
    this.setState({ searchNotFound: false })
    if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
      this.getAllPatients();
    }
    for (let key in searchInfo) {
      if (searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
        this.getAllVisits();

      } else {
        this.setState({
          patientLoading: true,
          errMsg: "",
        });
        if (searchInfo.lastname === "") {
          delete searchInfo.lastname;
        }
        let result = await axios.put(
          KayanURL + "api/KSA/RCM/patient/getPatients",
          {
            searchInfo,
            apiToken: Cookies.get("RCM_KSA_Employee_Token"),
          }
        );
        if (result) {
          let { data } = result;
          if (data) {
            this.setState({ patientLoading: false });
            /*  this.setState({ requestsFound: true }); */
            if (data.success) {
              if (data.patients.length == 0) {
                this.setState({
                  searchNotFound: true,
                });
              } else {
                this.setState({
                  searchNotFound: false,
                });
              }
              this.setState({
                success: true,
                allPatients: data.patients,
              });
            } else {
              this.setState({
                success: false,
                error: data.error,
              });
            }
          }
        }
      }
    }
    this.setState({
      searchInfo: {},
      identifier: "",
      name: "",
    });
  };
  handleSearchRequestOnFarabyDatabase = async () => {
    this.setState({ searchLoading: true, searchMsg: "" });
    let { identifierInput, msgFordigitIdentifier } = this.state;
    if (!identifierInput || identifierInput === "") {
      this.setState({ searchMsg: "please enter a value !", searchLoading: false })
    } else if (msgFordigitIdentifier !== "") {
      this.setState({ searchMsg: "please enter a valid identifier value !", searchLoading: false })
    } else {
      let result = await axios.put(
        KayanURL + "api/KSA/RCM/faraby/getPatient",
        {
          identifier: identifierInput,
        }
      );
      if (result) {
        let { data } = result;
        if (data) {
          this.setState({ searchLoading: false });
          if (data.success) {
            if (data.patients && data.patients.length > 0) {
              this.setState({
                searchSuccess: true,
                patientInformation: data.patients,
              });
            }
          } else {
            this.setState({
              searchSuccess: false,
              searchError: data.error,
            });
          }


        }
      }
      this.setState({
        identifierInput: "",
      });
    }

  };
  handleRegistration = async (e) => {
    e.preventDefault();
    let { patientInformation } = this.state;
    patientInformation = patientInformation[0];
    console.log(patientInformation)
    this.setState({ iqamaFoundMessage: "" })
    if (this.state.msgFordigitIqama == "") {
      this.setState({ RegistrationError: "" })
      let addNewPatientResult = await axios.post(
        KayanURL + "api/KSA/RCM/patient/addNewPatient",
        {
          patient: {
            identifier: patientInformation["Patient ID"],
            firstName: patientInformation["First Name"],
            birthDate: patientInformation["Birth Date"],
            lastName: patientInformation["Last Name"],
            identifiersType: patientInformation["ID Types"],
            nationality: patientInformation["Nationality"],
            phone: patientInformation["Phone 1"],
            gender: patientInformation["Gender"],
            medicalfilenumber: patientInformation["Medical File No"]
          },
          apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        }
      );
      if (addNewPatientResult) {
        this.setState({
          requestSent: false,
          response: true,
          iqamaFoundMessage: "",
        });
        let { data } = addNewPatientResult;
        if (data) {
          if (data.success) {
            this.setState({ registratiomMsg: "Patient Added Successfully", })
          }
        }

      }

    }
  };
  HandleSearchChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let patientName,
      patientLastName = "";

    if (name === "identifierInput") {
      if (value === "") {
        this.setState({ msgFordigitIdentifier: "", [name]: value });
      } else if (value.length !== 10) {
        this.setState({
          msgFordigitIdentifier: "Iqama must be 10 digits",
          [name]: value,
        });
      } else {
        this.setState({ msgFordigitIdentifier: "", [name]: value });
      }
    } else if (name === "name") {
      patientName = value.trim().split(" ");
      if (patientName.length > 1) {
        for (let i = 1; i < patientName.length; i++) {
          patientLastName += patientName[i] + " ";
        }
        this.setState({
          searchInfo: {
            ...this.state.searchInfo,
            firstname: patientName[0],
            lastname: patientLastName.trim(),
          },
          [name]: value,
        });
      } else {
        this.setState({
          searchInfo: {
            ...this.state.searchInfo,
            firstname: patientName[0],
            lastname: "",
          },
          [name]: value,
        });
      }
    } else if (name === "identifier") {
      if (value === "") {
        this.setState({ msgFordigitIqama: "", [name]: value });
      } else if (value.length !== 10) {
        this.setState({
          msgFordigitIqama: "Iqama must be 10 digits",
          [name]: value,
        });
      } else {
        this.setState({
          msgFordigitIqama: "",
          searchInfo: { ...this.state.searchInfo, [name]: value },
          [name]: value,
        });
      }
    }
  };


  handleUpdateClaim = (index) => {
    this.setState({
      updateModal: true,
    });
    let arrayOfClaimInfo = [];
    let { allClaims } = this.state;
    let selectedClaim = allClaims.filter((c) => {
      return c.patientid == index;
    });
    if (selectedClaim && selectedClaim.length > 0) {
      arrayOfClaimInfo.push({
        patientid: selectedClaim[0].patientid,
        payerid: selectedClaim[0].payerid,
        diagnosis: selectedClaim[0].diagnosis,
        claimtype: selectedClaim[0].claimtype,
        proceduresforneedaproval: selectedClaim[0].proceduresforneedaproval,
        category: selectedClaim[0].category,
        allprocedures: selectedClaim[0].allprocedures,
      });
      this.setState({ arrayOfClaimInfo });
    }
  };
  handleCloseUpdate = () => {
    this.setState({ updateModal: false });
    this.getAllclaims();
  };
  handleOpen = () => {
    this.setState({ claimModal: true, claimOpen: true });
  };
  handlaOpenSearchReqauest = () => {
    this.setState({ searchRequestModal: true });
  };
  handleClose = () => {
    this.setState({
      patientInfoModalOpen: false,
    });
    // this.getAllclaims();
  };
  handleCloseSearchModal = () => {
    this.setState({
      searchModule: false,
      patientInformation: undefined,
      searchError: "",
      registratiomMsg: "",
      searchMsg: ""
    });
    this.getAllPatients();
  };
  backToPatientScreenFromPatientRegistrationScreen = (e) => {
    this.setState({
      registerModuleScreen: false,
      patients: true,
      viewPatientInfo: false,
      patientSearch: [],
      // iqamaValueFromSearch: "",
      //     setIqamaValueInPatientRegistration: false,
    });
    this.getAllPatients();
  };
  backToPatientScreenFromUpdatePatientScreen = (e) => {
    this.setState({
      patientupdate: false,
      patients: true,
    });
    this.getAllPatients();
    // this.getAllclaims();
  };
  handleDeletePatient = async (index) => {
    let deletePatient = await axios.put(
      KayanURL + "api/KSA/RCM/patient/deletePatientById",
      { id: index, apiToken: Cookies.get("RCM_KSA_Employee_Token") }
    );
    if (deletePatient) {
      let { data } = deletePatient;
      if (data) {
        console.log(data, "deleteee");
        if (data.success) {
          this.setState({ success: true });
          this.getAllPatients();
          // this.getAllclaims();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };
  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };
  handleUpdatePatient = async (index) => {
    this.setState({
      patientupdate: true,
      patients: false,
    });
    let arrayOfpatientInfo = [];
    let { allPatients } = this.state;
    let selectedPatient = allPatients.filter((p) => {
      return p.id == index;
    });
    if (selectedPatient && selectedPatient.length > 0) {
      arrayOfpatientInfo.push({
        patientId: selectedPatient[0].id,
        firstname: selectedPatient[0].firstname,
        lastname: selectedPatient[0].lastname,
        identifier: selectedPatient[0].identifier,
        identifiertype: selectedPatient[0].identifiertype,
        gender: selectedPatient[0].gender,
        birthdate: selectedPatient[0].birthdate,
        phone: selectedPatient[0].phone,
        nationality: selectedPatient[0].nationality,
      });
      this.setState({ arrayOfpatientInfo });
    }
  };
  HandleDateChange = (e) => {
    let date = moment(e.value.$d).format("YYYY-MM-DD");
    this.setState({ [e.name]: date });
  };
  getAllPatients = async () => {
    this.setState({ patientLoading: true })
    let Allpatients = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getPatients",
      { apiToken: Cookies.get("RCM_KSA_Employee_Token") }
    );
    if (Allpatients) {
      let { data } = Allpatients;
      if (data) {
        this.setState({ patientLoading: false })
        if (data.success) {
          this.setState({
            success: true,
            allPatients: data.patients,
            allpatientsForSearchIqama: data.patients,
          });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allPatients: data.patients,
            allpatientsForSearchIqama: data.patients,
          });
        }
      }
    }
  };

  handleCheckBox = (e, id) => {
    let { allClaims } = this.state;
    if (e.target.checked) {
      let selectedClaimByPatientId = allClaims.filter((element) => {
        return element.patientid == id;
      });

      this.setState({ allClaims: selectedClaimByPatientId });
    } else {
      this.getAllclaims();
    }
  };


  render() {
    let {
      allPatients,
      patientInformation
    } = this.state;
    let patientRows, patientInformationRows;
    if (allPatients && allPatients.length > 0) {
      // console.log(allPatients)
      patientRows = allPatients.map((element, index) => {
        const year = new Date().getFullYear();
        const dateSplit = element.birthdate.split("-");
        const birthYear = dateSplit[0];
        const age = year - birthYear;
        return (
          <TableRow key={index}>
            {/* <TableCell align="center">
          <Checkbox name="patientCheck"
            onChange={(e) => this.handleCheckBox(e,element.id)}
            />
          </TableCell> */}
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.id}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <a
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => {
                  this.setState({
                    viewPatientInfo: true,
                    iqamaValue: element.identifier,
                    patients: false,
                  });
                }}
              >
                {element.firstname + " " + element.lastname}
              </a>
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.identifier}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {element.identifiertype}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {element.gender}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.birthdate}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {age}Years
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.medicalfilenumber}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.phone && element.phone != "undefined" ? element.phone : ""}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.createdat}
            </TableCell>
            <TableCell align="center">
              <MoreOptions
                index={element.id}
                handleDelete={() => this.handleDeletePatient(element.id)}
                handleUpdate={() => this.handleUpdatePatient(element.id)}
                optionFor="patient"
              />
            </TableCell>
          </TableRow>
        );
      });
    }
    if (patientInformation && patientInformation.length > 0) {
      // console.log(allPatients)
      patientInformationRows = patientInformation.map((element, index) => {
        const year = new Date().getFullYear();
        const dateSplit = element["Birth Date"].split("-");
        const birthYear = dateSplit[0];
        const age = year - birthYear;
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["First Name"] + " " + element["Last Name"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["Patient ID"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["ID Types"]}
            </TableCell>


            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {element.Gender}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["Birth Date"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {age}Years
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["Medical File No"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["Phone 1"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["Insurance No."]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {element.Nationality}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {element["Create Date"]}
            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <>
        <Box height={60} />
        <div
          style={{
            textAlign: "left",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px",
          }}
        >
          {this.state.patients ? (
            <>
              <div
                style={{

                  marginTop: "20px",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "rgb(97 110 120",
                    height: "40px",
                    width: "15%",
                  }}
                  onClick={() =>
                    this.setState({
                      registerModuleScreen: true,
                      patients: false,
                      setIqamaValueInPatientRegistration: false,
                    })
                  }
                >
                  <AddIcon style={{ paddingRight: "5px" }} /> Add patient
                </Button>
                <Accordion
                  defaultActiveKey="0"
                  style={{
                    margin: "auto",
                    paddingBottom: "20px",
                    width: "50%",
                  }}
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <span style={{ color: "grey" }}>Search Patient</span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Row>
                        <Col>
                          <FormControl fullWidth>
                            <TextField
                              InputLabelProps={{ sx: { fontSize: "small" } }}
                              inputProps={{ sx: { padding: "10px" } }}
                              type="number"
                              name="identifier"
                              label="Search Identifier"
                              variant="outlined"
                              value={this.state.identifier ? this.state.identifier : ""}
                              onChange={this.HandleSearchChange}
                            />
                          </FormControl>
                          {this.state.msgFordigitIqama ? (
                            <span style={{ color: "red", fontSize: "10px" }}>
                              {this.state.msgFordigitIqama}!
                            </span>
                          ) : null}

                        </Col>
                        <Col>
                          <FormControl fullWidth>
                            <TextField
                              InputLabelProps={{ sx: { fontSize: "small" } }}
                              inputProps={{ sx: { padding: "10px" } }}
                              type="text"
                              name="name"
                              label="Search Patient Name"
                              variant="outlined"
                              value={this.state.name ? this.state.name : ""}
                              onChange={this.HandleSearchChange}
                            />
                          </FormControl>
                        </Col>
                      </Row>
                      <Row>
                        <div style={{ width: "100%", marginTop: "20px", textAlign: "center" }}>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(97 110 120",
                              marginRight: "10px",
                            }}
                            onClick={(e) => this.handleSearchRequest(e)}
                          >
                            search
                          </Button>
                          {this.state.errMsg ? (
                            <>
                              <Typography style={{ textAlign: "center", color: "red" }}>
                                {this.state.errMsg}
                              </Typography>
                            </>
                          ) : null}
                        </div>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

              </div>
              <div>
                {this.state.patientLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress />
                  </div>
                ) : (
                  <>
                    {allPatients && allPatients.length > 0 ? (
                      <>
                        {/*   <h4>Patients Table</h4> */}

                        <TableContainer
                          component={Paper}
                          style={{ marginTop: "20px" }}
                        >
                          <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                {/* <TableCell align="center"></TableCell> */}
                                <TableCell align="center">ID</TableCell>
                                <TableCell align="center">Name</TableCell>
                                <TableCell align="center"> Identifier</TableCell>
                                <TableCell align="center"> Identifier Type</TableCell>
                                <TableCell align="center">Gender</TableCell>
                                <TableCell align="center">Birth Date</TableCell>
                                <TableCell align="center">Age</TableCell>
                                <TableCell align="center">
                                  medical File Number
                                </TableCell>
                                <TableCell align="center">Phone</TableCell>
                                <TableCell align="center">Created At</TableCell>
                                <TableCell align="center">Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{patientRows}</TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : (
                      <>


                        {/* <span>
                      <a
                        style={{
                          textDecoration: "underline",
                          color: "grey",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({
                            registerModuleScreen: true,
                            patients: false,
                          })
                        }
                      >
                        Add Patient
                      </a>
                    </span> */}
                        {this.state.searchNotFound ? (
                          <>
                            <h3
                              style={{
                                marginTop: "30px",
                                textAlign: "center",
                                fontSize: "small",
                              }}
                            >
                              The entered information does not match any patients in the system{" "}
                            </h3>
                            <div
                              style={{
                                textAlign: "center",
                                marginTop: "20px",
                              }}
                            >
                              <Button
                                variant="contained"
                                style={{
                                  backgroundColor: "rgb(97 110 120",
                                  height: "30px",
                                  width: "20%",
                                }}
                                onClick={() =>
                                  this.setState({
                                    searchModule: true,
                                  })
                                }
                              > Check External DB
                              </Button>
                            </div>
                          </>

                        ) : null}

                      </>
                    )}
                  </>
                )}
              </div>


              <hr />
              {this.state.searchModule ? (
                <>
                  <Modal
                    open={this.state.searchModule}
                    onClose={this.handleCloseSearchModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  // style={{ overflowY: "scroll" }}
                  >
                    <Box
                      sx={styleModal}
                      style={{
                        width: patientInformation ? "70%" : "30%",
                        height: patientInformation ? "600px" : "200px",
                      }}
                    >
                      <Row>
                        <Col>
                          <FormControl style={{ width: patientInformation ? "30%" : "100%" }}>
                            <TextField
                              InputLabelProps={{ sx: { fontSize: "small" } }}
                              inputProps={{ sx: { padding: "10px" } }}
                              type="number"
                              name="identifierInput"
                              label="Search Identifier"
                              variant="outlined"
                              value={this.state.identifierInput ? this.state.identifierInput : ""}
                              onChange={this.HandleSearchChange}
                            />
                          </FormControl>
                          {this.state.msgFordigitIdentifier ? (
                            <span style={{ color: "red", fontSize: "10px" }}>
                              {this.state.msgFordigitIdentifier}!
                            </span>
                          ) : null}

                        </Col>

                      </Row>
                      <Row>
                        <div style={{ width: "100%", marginTop: "20px", textAlign: patientInformation ? "left" : "center" }}>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(97 110 120",
                              marginRight: "10px",
                            }}
                            onClick={(e) => this.handleSearchRequestOnFarabyDatabase(e)}
                          >
                            search
                          </Button>
                          {this.state.searchMsg ? (
                            <>
                              <Typography style={{ textAlign: "center", color: "red" }}>
                                {this.state.searchMsg}
                              </Typography>
                            </>
                          ) : null}
                          <div>
                            {this.state.searchLoading ? (
                              <div style={{ textAlign: "center" }}>
                                <CircularProgress />
                              </div>
                            ) : (
                              <>

                                {this.state.searchSuccess &&
                                  this.state.patientInformation &&
                                  this.state.patientInformation.length > 0 ? (
                                  <>
                                    <div style={{ width: "20%", marginLeft: "auto", marginBottom: "10px" }}>
                                      <Button
                                        variant="primary"
                                        type="submit"
                                        onClick={(e) => this.handleRegistration(e)}
                                        style={{
                                          width: "100%",
                                          backgroundColor: "rgb(97 110 120",
                                          border: "1px solid rgb(97 110 120",
                                          color: "white"
                                        }}
                                      >
                                        Register
                                      </Button>
                                    </div>
                                    <TableContainer
                                      component={Paper}
                                      style={{ marginTop: "20px", height: "350px", overflowY: "scroll" }}
                                    >
                                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                                          <TableRow style={{ textAlign: "center" }}>
                                            <TableCell align="center">Name</TableCell>
                                            <TableCell align="center"> Identifier</TableCell>
                                            <TableCell align="center">Identifier Type</TableCell>
                                            <TableCell align="center">Gender</TableCell>
                                            <TableCell align="center">Birth Date</TableCell>
                                            <TableCell align="center">Age</TableCell>
                                            <TableCell align="center">
                                              medical File Number
                                            </TableCell>
                                            <TableCell align="center">Phone</TableCell>
                                            <TableCell align="center">Insurance No</TableCell>
                                            <TableCell align="center"> Nationality</TableCell>
                                            <TableCell align="center"> Created At</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>{patientInformationRows}</TableBody>
                                      </Table>
                                    </TableContainer>

                                    {this.state.registratiomMsg ? (
                                      <div style={{ textAlign: "center", marginTop: "15px", fontSize: "15px" }}>
                                        <h5 style={{ color: "green", fontSize: "small" }}>
                                          {this.state.registratiomMsg}
                                        </h5>
                                      </div>
                                    ) : null}
                                  </>
                                ) : !this.state.searchSuccess && !this.state.searchError && this.state.patientInformation === "undefined" ? (
                                  <>
                                    <h3
                                      style={{
                                        marginTop: "30px",
                                        textAlign: "center",
                                        fontSize: "small",
                                      }}
                                    >
                                      The entered information does not match any patients in the system{" "}

                                    </h3>
                                  </>
                                ) : this.state.searchError ? (
                                  <Typography style={{ textAlign: "center", color: "red" }}>
                                    {this.state.searchError}
                                  </Typography>
                                ) : null}
                              </>
                            )}
                          </div>
                        </div>
                      </Row>
                    </Box>
                  </Modal>
                </>
              ) : null}
              {this.state.updateModal ? (
                <>
                  <Modal
                    open={this.state.updateModal}
                    onClose={this.handleCloseUpdate}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ overflowY: "scroll" }}
                  >
                    <Box
                      sx={styleModal}
                      style={{
                        width: "60%",
                        height: "470px",
                        overflowY: "scroll",
                      }}
                    >
                      <UpdateClaim
                        selectedClaim={this.state.arrayOfClaimInfo}
                        closeModal={this.handleCloseUpdate}
                      />
                    </Box>
                  </Modal>
                </>
              ) : null}
            </>
          ) : null}
          {this.state.viewPatientInfo ? (
            <>
              <PatientRegistration
                backToPatientScreen={
                  this.backToPatientScreenFromPatientRegistrationScreen
                }
                registerformfrom="view"
                backFlag="true"
                iqamaValueFromSearch={
                  this.state.iqamaValue ? this.state.iqamaValue : null
                }
              />
            </>
          ) : null}
          {this.state.registerModuleScreen ? (
            <>
              {/*  <h4 style={{ margin: "50px 0 20px 96px" }}>New Patient</h4> */}
              <PatientRegistration
                backToPatientScreen={
                  this.backToPatientScreenFromPatientRegistrationScreen
                }
                iqamaValueFromSearch={
                  this.state.setIqamaValueInPatientRegistration
                    ? this.state.iqamaValueFromSearch
                    : null
                }
              />
            </>
          ) : null}
          {this.state.patientupdate ? (
            <UpdatePatient
              selectedPatient={this.state.arrayOfpatientInfo}
              selectedInsurance={this.state.selectedInsurance}
              backToPatientScreen={
                this.backToPatientScreenFromUpdatePatientScreen
              }
            />
          ) : null}
        </div>
      </>
    );
  }
}
export default Patients;
